import { TextCodes } from '@api/types/translation/TextCodes';
import { Title, useWarrantyClaimContext } from '@components';
import { useAuth } from '@hooks';
import { Box, Divider, Grid, TextField, styled } from '@mui/material';
import { t } from '@translations';

const TextArea = styled(TextField)(() => ({
  '& .MuiOutlinedInput-root': {
    padding: '0 !important',
    height: 'auto',
  },
}));

export const WarrantyCommentsSection = () => {
  const { form } = useWarrantyClaimContext();
  const { isBeremaUser } = useAuth();
  const hasExternalComment = form.watch('comment');
  return hasExternalComment || isBeremaUser ? (
    <Box sx={{ mb: 6 }}>
      <Divider sx={{ my: 4 }} />
      <Title noDot variant='h3' sx={{ mb: 2 }}>
        {t(TextCodes.Warranty.Block.Comment)}
      </Title>
      <Grid container spacing={2}>
        {isBeremaUser && (
          <Grid item xs={12} md={6}>
            <TextArea
              label={t(TextCodes.Warranty.Block.Internal)}
              fullWidth
              multiline
              rows={4}
              sx={{ mt: 4, mb: 2 }}
              {...form.register('internalComment')}
            />
          </Grid>
        )}
        <Grid item xs={12} md={6}>
          {(isBeremaUser || hasExternalComment) && (
            <TextArea
              label={t(TextCodes.Warranty.Block.Comment)}
              fullWidth
              multiline
              rows={4}
              sx={{ mt: 4, mb: 2 }}
              inputProps={{ readOnly: !isBeremaUser }}
              {...form.register('comment')}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  ) : null;
};
